import { quoteRsqlValue } from "../rsql";

export function buildAnomalyEventListFilter(options: {
  customerId?: string;
  category?: string | null;
  subCategory?: string | null;
}): string | undefined {
  const parts: string[] = [];
  const customerId = options.customerId?.trim();
  const category = options.category?.trim();
  const subCategory = options.subCategory?.trim();

  if (customerId) {
    parts.push(`customerId==${customerId}`);
  }
  if (category) {
    parts.push(`category==${quoteRsqlValue(category)}`);
  }
  if (subCategory) {
    parts.push(`subCategory==${quoteRsqlValue(subCategory)}`);
  }

  return parts.length > 0 ? parts.join(";") : undefined;
}
